/* eslint-disable max-len */
import React from 'react'
import MetaHeaders from '../../components/nfttemplate/metaheaders'
import NftTagManager from '../../components/nfttemplate/nfttagmanager'
import Banner from '../../components/nfttemplate/banner'
import Header from '../../components/nfttemplate/header'
import Gallery from '../../components/nfttemplate/gallery'
import GalleryComponent from '../../components/nfttemplate/gallerycomponent'
import MilestoneBenefits from '../../components/nfttemplate/milestonebenefits'
import MilestoneBenefitsComponent from '../../components/nfttemplate/milestonebenefitscomponent'
import Team from '../../components/nfttemplate/team'
import TeamComponent from '../../components/nfttemplate/teamcomponent'
import About from '../../components/nfttemplate/about'
import Footer from '../../components/nfttemplate/footer'
import NavComponent from '../../components/nfttemplate/navcomponent'
import AboutDescription from '../../components/nfttemplate/aboutdescription'
import Tiles from '../../components/nfttemplate/tiles'
import Roadmap from '../../components/nfttemplate/roadmap'
import Video from '../../components/nfttemplate/video'
import GeniusBar from '../../components/nfttemplate/geniusbar'

import logo from '../../assets/nfttemplate/logo-black.svg'
import aboutImage from '../../assets/macpunks/macpunk-footer.jpg'
import john from '../../assets/macpunks/john.jpeg'
import idris from '../../assets/macpunks/idris.jpg'
import jaraad from '../../assets/macpunks/jaraad.jpeg'
import stich from '../../assets/macpunks/stich.png'
import paul from '../../assets/macpunks/paul.jpg'
import maryam from '../../assets/macpunks/maryam.jpg'
import geniusbar from '../../assets/macpunks/geniusbar.png'
import desktopImg from '../../assets/macpunks/macpunks-ultrawide-header.jpg'
import mobileImg from '../../assets/macpunks/macpunks-hero-mobile.png'
import macPunk1 from '../../assets/macpunks/macpunks-1.png'
import macPunk2 from '../../assets/macpunks/macpunks-2.png'
import macPunk3 from '../../assets/macpunks/macpunks-3.png'
import macPunk4 from '../../assets/macpunks/macpunks-4.png'
import milestoneBenefitsImage from '../../assets/macpunks/macpunks-roadmap-bg.png'
import customOgImage from '../../assets/macpunks/macpunks-og.jpg'
import closedNavImg from '../../assets/nfttemplate/x-black.svg'
import openNavImg from '../../assets/nfttemplate/ham-black.svg'
import discord from '../../assets/nfttemplate/discord-black.svg'
import twitter from '../../assets/nfttemplate/twitter-black.svg'
import insta from '../../assets/nfttemplate/insta-black.svg'

import './MacPunks.module.scss'

const fontColour = '#000'

function MacPunks() {
    return (
        <div className="macpunks">
            <MetaHeaders
                title="MACPUNKS NFT | urbancoolab"
                description="1984 Unique Characters representing the rebels, the misfits, and the revolutionaries building a new tomorrow."
                customOgImage={customOgImage}
            />
            <Header
                logo={logo}
                openNavImg={openNavImg}
                closedNavImg={closedNavImg}
            >
                <NavComponent colour={fontColour} nav="Mint" link="https://mint.urbancoolab.com/macpunks/" />
                <NavComponent colour={fontColour} nav="Intro" link="#video" />
                <NavComponent colour={fontColour} nav="Story" link="#story" />
                <NavComponent colour={fontColour} nav="Roadmap" link="#roadmap" />
                <NavComponent colour={fontColour} nav="Team" link="#team" />
                <div className="headerSocialMedia">
                    <a href="https://discord.com/invite/S3UYg6EQtQ">
                        <img src={discord} alt="discord" />
                    </a>
                    <a href="https://twitter.com/urbancoolab">
                        <img src={twitter} alt="twitter" />
                    </a>
                    <a href="https://www.instagram.com/urbancoolab_/">
                        <img src={insta} alt="instagram" />
                    </a>
                </div>
            </Header>
            <Banner
                title="Macpunks"
                desktopImg={desktopImg}
                mobileImg={mobileImg}
                openSeaLink="https://mint.urbancoolab.com/macpunks/"
                buttonTitle="MINT YOUR MACPUNK"
            />

            <Video
                title="1984"
                videoLink="https://vimeo.com/678247596"

            />
            <Gallery
                title="Macpunks"
                subheading="1984 Unique Characters representing the rebels, the misfits, and the revolutionaries building a new tomorrow."
                bylineCopy="Here&#39;s to the MACPUNKS. The misfits, the rebels, the troublemakers, the round pegs in the square holes, the ones who see things differently. They're not fond of rules, and they have no respect for the status quo. You can quote them, disagree with them, glorify or vilify them. MACPUNKs are the kinds of people who love thinking up new business ideas, especially in the crypto-space. If you&#39;ve ever thought “We should make an NFT collection based on…” or “what about a DAO that…” then you&#39;re dipping your toes into creativity."
                bylineCopy2="Our goal when we created MACPUNKs was to build quirky characters made from our two sources of inspiration. The original: cryptopunks&#39; mantra merged with the original idea of Apple: inventor culture (geniuses). Based on the original macintosh and punk-style characters, we created 1984 geniuses to inspire you to forget about the status quo, and dream bigger."
                bylineCopy3="When you&#39;re part of the MACPUNK community, you&#39;re celebrating geniuses, maverick thinkers, and failures as well as success (or you are one). You&#39;re becoming part of a closed community that is working together to nurture new business ideas that will help the cause for decentralization and the crypto-community. And we&#39;re putting in $200,000 USD behind it plus more than $200,000 USD of strategic guidance and mentorship to the chosen projects. The money can be used to build the early prototype and we will help to find investors. You will be part of a group that&#39;s going to change the world as we know it."
            >
                <GalleryComponent
                    image={macPunk1}
                    alt="A.I. GENERATION"
                    title="A.I. GENERATION"
                    description="Each MACPUNK has a unique set of traits and unlocks generated by our AI, “STiCH”. Originally trained in streetwear fashion and pop art, our AI has pulled different combinations of styles and faces to put together this small collection of misfits and rebels."
                />
                <GalleryComponent
                    image={macPunk2}
                    alt="INTRAVERSE"
                    title="INTRAVERSE"
                    description="The 1984 MACPUNKS take the first steps into the INTRAVERSE. Our vivid inter-reality space to build bridges between the real world and the metaverse. Includes forging for limited run collectibles, staking for real-life values, and being able to invest in real-world things with your crypto."
                />
                <GalleryComponent
                    image={macPunk3}
                    alt="GENIUS DAO"
                    title="GENIUS DAO"
                    description="Join a community of disruptors, design thinkers, and web 3.0 entrepreneurs to build the next phase of the Metaverse. Get advisory from the top design thinking guru (valued over $300,000) and get up to $200,000 to fund your startup idea"
                />
                <GalleryComponent
                    image={macPunk4}
                    alt="BETA-ACCESS"
                    title="BETA-ACCESS"
                    description="The MACPUNKs are the first edition of urbancoolab&#39;s many drops and collaborations. Holders will get first dibs on beta-access for our services, whitelisting for our future drops, and other coolaborator benefits. "
                />
            </Gallery>

            <Tiles />

            <GeniusBar
                title="The Genius Bar"
                image={geniusbar}
                alt="A.I. generated artist studio"
                text="If there was ever a time to dare to make a difference, Web 3.0 is here. You owe it to yourself to make your days here count. Have fun. Dig deep. Push the limits of creativity. Here is where we come together to dream and to action. The MACPUNKS will get together to come up with ideas, our community will help prototype these ideas, and our team of advisors will help nurture the business, with cash to back it up. We also put together a little complimentary swag for the dreamers with the best ideas."
            />

            <Roadmap />

            <MilestoneBenefits title="Milestone Benefits" bgImage={milestoneBenefitsImage}>
                <MilestoneBenefitsComponent
                    title="20%"
                    text="Once we meet 20%, we will start building the Cool Community of our holders to spark excitement and foster networks that will empower our community."
                    number="20%"
                    milestoneBenefitsComponentStyles={{ background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(217,217,217,1) 100%)', border: '2px solid grey' }}
                />
                <MilestoneBenefitsComponent
                    title="40%"
                    text="Once 40% has been achieved, our Cool Merch store will be unlocked! The community will be able to vote and create the merch they want to rock. All Macpunk holders will also be able to receive discounts from all items on our store as well."
                    number="40%"
                    milestoneBenefitsComponentStyles={{ background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(217,217,217,1) 100%)', border: '2px solid grey' }}
                />
                <MilestoneBenefitsComponent
                    title="60%"
                    text="After we achieve 60%, we will be able to deliver $50,000 in funding for ideas created by our holders."
                    number="60%"
                    milestoneBenefitsComponentStyles={{ background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(217,217,217,1) 100%)', border: '2px solid grey' }}
                />
                <MilestoneBenefitsComponent
                    title="80%"
                    text="At 80% we will be able to deliver $100,000 in funding for ideas created by our holders."
                    number="80%"
                    milestoneBenefitsComponentStyles={{ background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(217,217,217,1) 100%)', border: '2px solid grey' }}
                />
                <MilestoneBenefitsComponent
                    title="100%"
                    text="Once we have achieved 100%, we will fund bigger ideas to help transform the future of the Metaverse. "
                    number="100%"
                    milestoneBenefitsComponentStyles={{ background: 'linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(217,217,217,1) 100%)', border: '2px solid grey' }}
                />
            </MilestoneBenefits>

            <Team
                title="Team"
            >
                <TeamComponent
                    image={idris}
                    alt="Idris Mootee"
                    name="Idris Mootee"
                    title="The Billion-dollar Design Thinker"
                    description="A Big Thinker and described as 'the ultimate foresight machine' and 'design thinking guru', Idris is one of the most sought after innovation advisors among top companies including Samsung, LG, Prudential, Citi, Cisco and Burberry. He is a serial entrepreneur and most recently the co-founder and global CEO of Idea Couture has conducted more than 100 projects in over 28 countries and created more than US$5 billion of economic value for our clients in a single year. He authored the best selling 'Design Thinking for Corporate Creativity' based on a program he designed and taught at Harvard GSD. Idris holds master degrees from London Business School and Brunel Business School."
                />
                <TeamComponent
                    image={jaraad}
                    alt="Jaraad Mootee"
                    name="Jaraad Mootee"
                    title="The Web3 Product Strategist"
                    description="Jaraad works and plays at the intersection of Web3 technology, business design and consumer insights. He focuses on the fuzzy front-end of innovation and white space exploration. With experience working with global consulting firms, Jaraad helps start-ups to conduct design research to create human-centric customer experiences and map behavior to product roadmap and experience design."
                />
                <TeamComponent
                    image={john}
                    alt="John Cavacas"
                    name="John Cavacas"
                    title="The Tech Master"
                    description="John is a seasoned technology leader with over 25 years of technology experience with top global digital agencies and global brands, most recently VP Technology with Critical Mass. His experiences included managing and mentoring global, distributed, and local development teams for Critical Mass, Blast Radius, Idea Couture, Softchoice Corporation, Sapiens, amongst others, he&#39;s very well versed in working with creative, business, and technical teams. "
                />
                <TeamComponent
                    image={maryam}
                    alt="Maryam Nabavi"
                    name="Maryam Nabavi"
                    title="Start-up Coach & AI Strategist"
                    description="CEO and co-founder of Babby, an award-winning venture funded startup focuses on building the world&#39;s largest data platform to track and support development in the first 1000 days of life. Maryam was trained as an Aerospace Engineer and later went to earn Master degrees from Imperial College and Royal College of Art, her past career was helping some of the top Fortune 500 companies to develop next generation products while solve human-centric problems. A well-rounded founder&#39;s coach with strong technical, capital raising, business model and go-to-market experience."
                />
                <TeamComponent
                    image={paul}
                    alt="Paul Rowan"
                    name="Paul Rowan"
                    title="Design Pioneer & Visionary"
                    description="Co-founded Umbra with childhood friend and entrepreneur Les Mandelbaum and began his 40 years history of original design. Umbra produced a prolific flow of innovative product under Paul&#39;s visionary leadership and 1998, in 2000 saw Paul Rowan&#39;s mesh can design added to the permanent collection of San Francisco Museum of Modern Art as well as an Honorable Mention by the City of Toronto Architecture and Urban Design for Umbra&#39;s world headquarters. Paul received numerous award including the Premier&#39;s Award for Outstanding Achievement from the colleges of Ontario, TD Centre&#39;s Salute to the City Award Program and a Tiffany Star for his contribution to Canada&#39;s fashion and design community and later inducted into the Canadian Marketing Hall of Legends as a Visionary."
                />
                <TeamComponent
                    image={stich}
                    alt="STICH"
                    name="STICH"
                    title="AI Development lab"
                    description="STiCH is the robo-NFT-designer -- an evolving collective of modern machine-learning modules, leveraging the best in generative prowess and procedural improvements in neural networks and genetic algorithms. The process itself is largely inspired by human design processes but powered by algorithmic efficiencies. "
                />
            </Team>

            <div className="footer-cta">
                <a href="https://mint.urbancoolab.com/macpunks/">
                    <span className="banner-hover-button">Mint your macpunk now</span>
                </a>
            </div>

            <About
                image={aboutImage}
                title="Us"
            >
                <AboutDescription
                    link="/"
                    description="
                    Urbancoolab (UCL) is an artificial-intelligence powered design lab and collab platform. UCL is a group of experienced technologists, designers, and developers creating intraverse experiences to bridge reality with the metaverse. Partnering with creative powers to design fashion collections, digital fashion, and NFT experiences."
                />
            </About>
            <Footer
                twitterLink="https://twitter.com/urbancoolab"
                instaLink="https://www.instagram.com/urbancoolab_/"
                discordLink="https://discord.com/invite/S3UYg6EQtQ"
                logo={logo}
                purchaseLink="https://mint.urbancoolab.com/macpunks/"
                twitter={twitter}
                insta={insta}
                discord={discord}
                colour={fontColour}
            >
                <NavComponent colour={fontColour} nav="Mint" link="https://mint.urbancoolab.com/macpunks/" />
                <NavComponent colour={fontColour} nav="Story" link="#intro" />
                <NavComponent colour={fontColour} nav="Roadmap" link="#roadmap" />
                <NavComponent colour={fontColour} nav="Milestones" link="#milestone" />
            </Footer>
            <NftTagManager />
        </div>
    )
}

export default MacPunks
